import { ErrorMessage, Field } from 'formik'

export function FormSelect({
  name,
  label,
  options = [],
  placeholder = 'Select an option',
  required = false,
  className = '',
  showLabel = true,
  ...props
}) {
  return (
    <div className="w-full">
      {showLabel && (
        <label
          htmlFor={name}
          className="block text-left font-sans text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2"
        >
          {label}
        </label>
      )}
      <Field name={name}>
        {({ field, meta }) => (
          <>
            <select
              {...field}
              {...props}
              id={name}
              required={required}
              className={`w-full min-w-0 border-2 border-foreground/20 bg-card px-4 py-3 text-base text-foreground font-serif transition-all focus:outline-none focus:border-foreground focus:bg-background ${
                meta.touched && meta.error
                  ? 'border-destructive focus:border-destructive'
                  : ''
              } ${className}`}
            >
              <option value="" disabled>
                {placeholder}
              </option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <ErrorMessage
              name={name}
              component="div"
              className="mt-2 text-sm text-destructive font-sans"
            />
          </>
        )}
      </Field>
    </div>
  )
}
